"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _settingTab = _interopRequireDefault(require("./tab/settingTab"));
var _default = {
  components: {
    settingTab: _settingTab.default
  },
  data: function data() {
    return {
      activeName: 'setting',
      id: 0
    };
  },
  created: function created() {
    this.id = this.$route.params.viewId;
  },
  methods: {
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
    }
  }
};
exports.default = _default;